import React from 'react';
import { connect } from 'react-redux';
import RolesTable from './RolesTable';

import Collapsible from '../../util/Collapsible';

const RolesOverview = ({ scrollTop, defaultOpen }) => (
  <Collapsible headerContent="Roles" defaultOpen={defaultOpen}>
    <RolesTable scrollTop={scrollTop} />
  </Collapsible>
);

export default connect(
  ({
    users: {
      editing: { editType },
    },
  }) => ({
    defaultOpen: editType === 'NONE' || editType === 'ROLE',
  })
)(RolesOverview);
